// DS: i5.10
import React from 'react';
import IconWrap from '../../IconWrap';
const Private = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M4.5 5.313V4.5C4.5 2.385 6.366 1 8 1s3.5 1.385 3.5 3.5v.813l2.176 1.122c.201.103.324.29.324.491v3.428c0 .164-.081.32-.224.428l-5.333 4.073a.75.75 0 01-.886 0l-5.333-4.073A.541.541 0 012 10.354V6.926c0-.201.123-.388.324-.491L4.5 5.313zm1-.813C5.5 3.02 6.832 2 8 2s2.5 1.02 2.5 2.5v.529a.71.71 0 00-.192.086L8 6.602 5.692 5.115a.71.71 0 00-.192-.086V4.5zm2.55 3.8a.8.8 0 01.8.8v2a.8.8 0 01-1.6 0v-2a.8.8 0 01.8-.8z",
        clipRule: "evenodd"
    })));
};
Private.displayName = 'Private';
export default Private;

//# sourceMappingURL=Private.js.map